export const NEXT_PARAM = "next";
export const CURRENT_PATH_HEADER = "x-appo-path";

const MAX_PATH_LENGTH = 2048;
const CONTROL_CHARS = /[\u0000-\u001f\u007f]/;

export function sanitizeNextPath(
  value: string | null | undefined,
): string | null {
  if (!value) return null;
  if (value.length > MAX_PATH_LENGTH) return null;
  if (!value.startsWith("/")) return null;
  if (value.startsWith("//") || value.startsWith("/\\")) return null;
  if (CONTROL_CHARS.test(value)) return null;

  // /login* would loop; /api* would land a freshly signed-in user on a JSON
  // response.
  const pathname = value.split(/[?#]/)[0];
  if (
    pathname === "/" ||
    pathname === "/login" ||
    pathname.startsWith("/login/") ||
    pathname === "/api" ||
    pathname.startsWith("/api/")
  ) {
    return null;
  }

  return value;
}

export function loginPathWithNext(
  dest: string | null | undefined,
  extra?: Record<string, string>,
): string {
  const params = new URLSearchParams(extra);
  const safe = sanitizeNextPath(dest);
  if (safe) params.set(NEXT_PARAM, safe);
  const query = params.toString();
  return query ? `/login?${query}` : "/login";
}
